import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {
  constructor(private http:HttpClient) { }

  
  getBusiness(page:any, itemsPerPage:any){
    return this.http.get('https://api.instantwebtools.net/v1/passenger?page='+page+'&size='+itemsPerPage);
  }
}
